<template lang="html">
  <div class="editor spritesheet">
  	<div class="container" style="display: flex;flex-direction: column;">
  		<div style="display: flex;width: 100%;height: 100%;align-items: center;justify-content: center;">
  			<div class="stage bg_transparent noselect"></div>
  		</div>
  		<div class="component frames">
  			<div v-for="(frames, name) in spritesheet.animations" :key="name" class="item" :class="{selected: name === selectedAnimation}">
  				<div class="name">{{name}}</div>
  				<div class="timeline">
  					<div v-for="(frame, index) in frames" :key="index" class="frame" :class="{selected: name === selectedAnimation && index === preview.frameIndex}">
  						<code>{{frame}}</code><br>
  						<i class="icon icon-fiber_manual_record"></i>
  					</div>
  				</div>
  			</div>
  		</div>
  	</div>
  	<div class="controls float-panel">
  		<div class="controls-group spritesheet-properties">
  			<label class="title">Spritesheet Properties</label>
  			<div style="padding: 0 10px 10px 10px;">
  				<label>Sprite Size</label>
  				<div v-for="(label, variable) in {frameWidth: 'W', frameHeight: 'H'}" :key="variable" class="input-group" style="width: 64px;margin-right: 7px;">
  					<input type="text" v-model="spritesheet[variable]" @input="renderPlaceholder()">
  					<span class="input-group-append">{{label}}</span>
  				</div>
  			</div>
  			<div style="padding: 0 10px 10px 10px;">
  				<label>Dimensions</label>
  				<div v-for="(label, variable) in {columns: 'cols', rows: 'rows'}" :key="variable" class="input-group" style="width: 72px;margin-right: 7px;">
  					<input type="text" v-model="spritesheet[variable]" @input="renderPlaceholder()">
  					<span class="input-group-append">{{label}}</span>
  				</div>
  			</div>
  		</div>
  		<div class="controls-group animations-list"></div>
  		<div class="controls-group animation-properties"></div>
  		<div class="controls-group animation-preview" v-show="selectedAnimation">
  			<label class="title">Animation Preview</label>
  			<div style="font-size: 14px;padding: 0 10px 10px 10px;">
  				<label>Duration</label>
  				<div class="input-group" style="margin-left: 0;">
  					<input type="text" v-model="preview.duration">
  					<span class="input-group-append">ms</span>
  				</div>
  				<label>Asset</label>
  				<select v-model="preview.asset">
  					<option value="0">Placeholder</option>
  					<option v-for="asset in preview.assets" :key="asset.id" :value="asset.id">{{asset.name}}</option>
  				</select>
  			</div>
  			<div class="select" style="display: flex;align-items: center;justify-content: center;">
  				<div class="previewContainer bg_transparent noselect"></div>
  			</div>
  			<div class="select-controls">
  				<button type="button" class="btn-icon" title="Play / Pause" @click="preview.play = !preview.play"><i :class="{'icon-pause': preview.play, 'icon-play_arrow': !preview.play}"></i></button>
  				<button type="button" class="btn-icon" title="Flip" @click="preview.flip = !preview.flip"><i class="icon-flip"></i></button>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
const Util = window.Util;
import GameStudio from '@/assets/js/GameStudio.js'

export default {
  props: ['fileData'],
  data: function () {
    return {
  		selectedAnimation: null,
  		spritesheet: this.fileData.data,
  		preview: {
  			assets: GameStudio.getFilesWithExtensions(['.png', '.jpg']),
  			duration: 1000,
  			asset: 0,
  			frameIndex: null,
  			flip: false,
  			play: true
  		}
    };
  },
  methods: {
    gerarPreview: function () {
			var previewContainer = this.$el.querySelector('.previewContainer');
			if (!previewContainer) return;
			previewContainer.innerHTML = '';
			var canvas = document.createElement('canvas');
			var factor = Math.min(230 / this.spritesheet.frameWidth, 150 / this.spritesheet.frameHeight);
			canvas.width = this.spritesheet.frameWidth * factor;
			canvas.height = this.spritesheet.frameHeight * factor;
			Util.canvasDisableImageSmoothing(canvas);
			previewContainer.appendChild(canvas);
		},
    renderPlaceholder: function () {
      var stage = this.$el.querySelector('.stage');
    	stage.innerHTML = '';
    	var canvas = this.getPlaceholderCanvas();
    	stage.appendChild(canvas);
    },
    getPlaceholderCanvas: function () {
    	var cols = this.spritesheet.columns;
    	var rows = this.spritesheet.rows;
    	var canvas = document.createElement('canvas');
    	canvas.width = cols * this.spritesheet.frameWidth;
    	canvas.height = rows * this.spritesheet.frameHeight;
    	Util.canvasDisableImageSmoothing(canvas);
    	var ctx = canvas.getContext('2d');
    	for (let y = 0; y < rows; y++) {
    		for (let x = 0; x < cols; x++) {
    			var color = ((x + y) % 2) ? '#ccc' : '#eee';
    			ctx.fillStyle = color;
    			ctx.fillRect(x * this.spritesheet.frameWidth, y * this.spritesheet.frameHeight, this.spritesheet.frameWidth, this.spritesheet.frameHeight);
    		}
    	}
    	ctx.fillStyle = "#000000";
    	ctx.font = (Math.min(this.spritesheet.frameWidth, this.spritesheet.frameHeight) / 2) + "px consolas";
    	ctx.textAlign = 'center';
    	ctx.textBaseline = 'middle';
    	for (let y = 0; y < rows; y++) {
    		for (let x = 0; x < cols; x++) {
    			var index = x + (y * cols);
    			ctx.fillText(index, x * this.spritesheet.frameWidth + this.spritesheet.frameWidth/2, y * this.spritesheet.frameHeight + this.spritesheet.frameHeight/2);
    		}
    	}
    	return canvas;
    },
    renderAnimationsList: function () {
      var self = this;
    	var controlsGroup = this.$el.querySelector('.animations-list');
    	controlsGroup.innerHTML = '';
    	controlsGroup.appendChild(Util.nodefy('<label class="title">Animations</label>'));
    	var animations = controlsGroup.appendChild(Util.nodefy('<div class="select">'));
    	Util.forEach(this.spritesheet.animations, function (frames, name) {
    		var item = animations.appendChild(Util.nodefy('<div class="option">' + name + '</div>'));
    		item.onclick = function () {
    			self.selectedAnimation = name;
    			self.renderAnimationsList();
    			self.renderAnimationProperties();
    			self.gerarPreview();
    		};
    		if (self.selectedAnimation == name) {
    			item.classList.add('selected');
    		}
    		if (self.spritesheet.defaultAnimation == name) {
    			item.innerHTML += ' <i class="icon-star" style="color: #ffa800;"></i>';
    		}
    	});
    	var selectControls = controlsGroup.appendChild(Util.nodefy('<div class="select-controls">'));
    	selectControls.appendChild(Util.nodefy('<button type="button" class="btn-icon" title="Add Animation"><i class="icon-note"></i></button>')).onclick = function () {
    		var new_name;
    		var i = 1;
    		do {
    			new_name = 'new' + i;
    			i++;
    		} while (self.spritesheet.animations[new_name]);
    		self.spritesheet.animations[new_name] = [];
    		self.selectedAnimation = new_name;
    		self.renderAnimationsList();
    		self.renderAnimationProperties();
    	};
    	if (!self.spritesheet.animations[self.selectedAnimation]) return;
    	selectControls.appendChild(Util.nodefy('<button type="button" class="btn-icon" title="Remove Animation"><i class="icon-delete"></i></button>')).onclick = function () {
    		if (!self.spritesheet.animations[self.selectedAnimation]) return;
    		delete self.spritesheet.animations[self.selectedAnimation];
    		self.selectedAnimation = null;
    		self.renderAnimationsList();
    		self.renderAnimationProperties();
    	};
    	if (self.spritesheet.defaultAnimation == self.selectedAnimation) return;
    	selectControls.appendChild(Util.nodefy('<button type="button" class="btn-icon" title="Make default animation"><i class="icon-star"></i></button>')).onclick = function () {
    		if (!self.spritesheet.animations[self.selectedAnimation]) return;
    		self.spritesheet.defaultAnimation = self.selectedAnimation;
    		self.renderAnimationsList();
    	};
    },
    renderAnimationProperties: function () {
      var self = this;
    	var controlsGroup = this.$el.querySelector('.animation-properties');
    	controlsGroup.innerHTML = '';
    	var frames = this.spritesheet.animations[this.selectedAnimation];
    	if (!frames) return;
    	controlsGroup.appendChild(Util.nodefy('<label class="title">Animation Properties</label>'));
    	var propertyEl = controlsGroup.appendChild(Util.nodefy('<div style="font-size: 14px;padding: 0 10px 10px 10px;">'));

    	propertyEl.appendChild(Util.nodefy('<label>Name</label>'));
    	var nameInput = propertyEl.appendChild(Util.nodefy('<input type="text">'));
    	nameInput.value = this.selectedAnimation;
    	nameInput.onchange = function () {
    		self.spritesheet.animations[nameInput.value] = frames;
    		delete self.spritesheet.animations[self.selectedAnimation];
    		self.selectedAnimation = nameInput.value;
    		self.renderAnimationsList();
    		self.renderAnimationProperties();
    	};

    	propertyEl.appendChild(Util.nodefy('<label>Frames</label>'));
    	var framesInput = propertyEl.appendChild(Util.nodefy('<input type="text">'));
    	framesInput.value = frames.join(',');
    	framesInput.onchange = function () {
    		frames.splice(0, frames.length);
    		Util.forArray((framesInput.value + '').split(','), function (frame) {
    			frame = parseInt(frame);
    			if (!isNaN(frame)) {
    				frames.push(frame);
    			}
    		});
    		self.renderAnimationProperties();
    	};
    }
  },
  mounted: function () {
    var self = this;
    this.$store.previewUpdate = function (now) {
    	var previewContainer = document.querySelector('.previewContainer');
    	if (!previewContainer) return;
    	var previewCanvas = previewContainer.querySelector('canvas');
    	if (!previewCanvas) return;
    	var ctx = previewCanvas.getContext('2d');
    	var animationName = self.selectedAnimation;
    	var animation = self.spritesheet.animations[animationName];
    	var duration = parseInt(self.preview.duration);
    	if (!duration || !self.preview.play) return;
    	var frameInterval = duration/animation.length;
    	var frameNumber = Math.trunc((now % duration) / frameInterval);
    	self.preview.frameIndex = frameNumber;
    	var coordIndex = animation ? animation[frameNumber % animation.length] : 0;
    	var coord = [coordIndex % self.spritesheet.columns, Math.floor(coordIndex/self.spritesheet.columns)];
    	var offset = {x: 0, y: 0};
    	var x = (coord[0] + offset.x) * self.spritesheet.frameWidth;
    	var y = (coord[1] + offset.y) * self.spritesheet.frameHeight;
    	var asset = GameStudio.getFileById(self.preview.asset);
    	if (asset) {
    		Util.loadImageSrc(asset.data, function (image) {
    			window.previewAsset = image;
    		});
    	} else {
    		window.previewAsset = null;
    	}
    	var image = window.previewAsset || document.querySelector('.stage canvas');
    	var frameCanvas = Util.sliceImageAsCanvas(image, x, y, self.spritesheet.frameWidth, self.spritesheet.frameHeight);
    	if (self.preview.flip) {
    		frameCanvas = Util.flipCanvas(frameCanvas);
    	}
    	ctx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
    	ctx.drawImage(frameCanvas, 0, 0, frameCanvas.width, frameCanvas.height, 0, 0, previewCanvas.width, previewCanvas.height);
    };
    this.renderAnimationsList();
  	this.renderPlaceholder();
  },
  beforeUnmount: function () {
    console.log('Destroy');
    this.$store.previewUpdate = null;
  }
}
</script>

<style lang="css" scoped>
.component.frames {
  background-color: rgba(41, 54, 61, 0.95);
  text-align: left;
  /* position: absolute;
  bottom: 0;
  left: 0;
  right: 0; */
  max-height: 200px;
  overflow: auto;
  flex: 1 0 auto;
}
.component.frames .item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  opacity: 0.5;
}
.component.frames .item.selected {
  opacity: 1;
}
.component.frames .item > * {
  display: inline-block;
}
.component.frames .item .name {
  min-width: 140px;
  color: rgba(255, 255, 255, 0.87);
  padding: 10px;
}
.component.frames .item.selected .name {
  color: #ffa800;
}
.component.frames .frame {
  cursor: pointer;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
  text-align: center;
  /* height: 36px;
  width: 36px; */
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 2px;
  min-width: 28px;
}
.component.frames .frame:hover {
  background-color: rgba(0, 0, 0, 0.2);
}
.component.frames .frame.selected {
  background-color: #ffa800;
  color: rgba(0, 0, 0, 0.87);
}
.component.frames .frame img {
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.editor.spritesheet .container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 250px;
  overflow: hidden;
  transition: right 0.7s;
}
.animations-list .select {
	height: auto;
	min-height: 160px;
}
</style>
